// extracted by mini-css-extract-plugin
export default {"svg_container":"spiner_svg_container__fk-xf","svg_load":"spiner_svg_load__BhXLv","rotate":"spiner_rotate__PrU8Z","load":"spiner_load__8HKKd"};